export type MyTasksSortMode = 'intelligent' | 'priority' | 'updated' | 'newest' | 'oldest';

const STORAGE_KEY = 'yoda.dashboard.myTasksFocus.sort';
const SORT_MODES: MyTasksSortMode[] = ['intelligent', 'priority', 'updated', 'newest', 'oldest'];

const isSortMode = (value: unknown): value is MyTasksSortMode =>
    typeof value === 'string' && (SORT_MODES as string[]).includes(value);

export const DEFAULT_MY_TASKS_SORT: MyTasksSortMode = 'intelligent';

export function loadMyTasksSortMode(): MyTasksSortMode {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return DEFAULT_MY_TASKS_SORT;
        }
        return isSortMode(raw) ? raw : DEFAULT_MY_TASKS_SORT;
    } catch {
        return DEFAULT_MY_TASKS_SORT;
    }
}

export function saveMyTasksSortMode(mode: MyTasksSortMode): void {
    try {
        if (!isSortMode(mode)) {
            return;
        }
        localStorage.setItem(STORAGE_KEY, mode);
    } catch {
        // Ignore quota / private mode failures.
    }
}
